export default function SubscriptionProduct() {
  return <div>
    
  </div>;
}
